var highUrl = 'http://stu.sunray365.com/#'

export default highUrl
